<template>
  <!-- モーダルウィンドウ -->
  <div class="c-modal" :class="[classes ? classes : '', { 'is-active': isActive }]">
    <div class="c-modal__bg" @click="handleClickOutside"></div>
    <div class="c-modal__content" :style="width ? { width: `${width}px` } : {}">
      <div class="c-modal__close" @click="onCloseClick">
        <div class="c-icon c-icon--white u-wh14">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <use xlink:href="/assets/img/sprite.svg#close" />
          </svg>
        </div>
      </div>
      <div class="c-modal__inner">
        <template v-if="isTitleHtml">
          <div class="c-modal__title" v-html="title"></div>
        </template>
        <template v-else>
          <div class="c-modal__title">{{ title }}</div>
        </template>
        <div v-if="errorMessage != ''" class="c-modal__error">{{ errorMessage }}</div>

        <template v-if="isBodyHtml">
          <div class="c-modal__data" v-html="body"></div>
        </template>
        <template v-else>
          <div class="c-modal__data">{{ body }}</div>
        </template>
        <!-- 同意チェックボックス -->
        <div class="c-modal__agreements c-checkbox">
          <div class="c-modal__agreement-item">
            <label class="c-checkbox__label">
              <input v-model="isAgreed" type="checkbox" name="agreement" />
              <div class="c-checkbox__item">
                <div class="c-checkbox__box"></div>
                <div class="c-checkbox__box-label">上記の内容を確認しました</div>
              </div>
            </label>
          </div>
        </div>

        <div class="c-modal__btns">
          <button
            v-if="cancelButtonLabel && onCancelClick"
            :class="[`c-btn c-btn--modal c-btn--gray ${buttonWidth} u-h34 u-fs14`]"
            type="button"
            name="cancel"
            value="cancel"
            @click="onCancelClick"
          >
            <p class="c-btn__text">{{ cancelButtonLabel }}</p>
          </button>
          <button
            v-if="enterButtonLabel && onEnterClick"
            v-tooltip="isAgreed ? '' : '内容を確認してチェックを入れてください'"
            :class="[`c-btn c-btn--modal c-btn--red ${buttonWidth} u-h34 u-fs14`, { 'is-loading': isLoading }]"
            type="button"
            name="delete"
            value="delete"
            :disabled="isLoading || !isAgreed"
            @click="onEnterClick"
          >
            <p class="c-btn__text">{{ enterButtonLabel }}</p>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- /モーダルウィンドウ -->
</template>

<script>
export default {
  props: {
    classes: { type: String, required: false },
    isActive: { type: Boolean, required: true },
    isBodyHtml: { type: Boolean, required: false },
    isTitleHtml: { type: Boolean, required: false },
    body: { type: String, required: false },
    cancelButtonLabel: { type: String, required: false },
    enterButtonLabel: { type: String, required: false },
    title: { type: String, required: false },
    canClickOutside: { type: Boolean, required: false, default: true },
    onCancelClick: { type: Function, required: false },
    onCloseClick: { type: Function, required: true },
    onEnterClick: { type: Function, required: false },
    width: { type: Number, required: false },
  },
  data() {
    return {
      errorMessage: '',
      isLoading: false,
      isAgreed: false,
    };
  },
  computed: {
    buttonWidth: function () {
      return this.cancelButtonLabel && this.enterButtonLabel ? 'u-w140' : 'u-w200';
    },
  },
  watch: {
    isActive(newValue) {
      // モーダルが表示されるたびにチェックをリセット
      if (newValue) {
        this.isAgreed = false;
      }
    },
  },
  methods: {
    showLoader() {
      this.isLoading = true;
    },
    hideLoader() {
      // 早すぎて変な表示になる事があるので、1拍おいてから非表示化
      setTimeout(() => {
        this.isLoading = false;
      }, 300);
    },
    toggleLoader() {
      this.isLoading = !this.isLoading;
    },
    async showErrorMessage(message) {
      this.errorMessage = message;
    },
    resetErrorMessage() {
      this.errorMessage = '';
    },
    handleClickOutside() {
      this.canClickOutside && this.onCloseClick();
    },
  },
};
</script>

<style scoped>
.c-modal__agreements {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  padding-right: 20px;
}

.c-modal__agreements .c-checkbox__label {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.c-modal__agreements .c-checkbox__item {
  display: inline-flex;
  align-items: center;
}

.c-modal__agreements .c-checkbox__box {
  width: 20px;
  height: 20px;
}

.c-modal__agreements .c-checkbox__box-label {
  font-size: 16px;
}

.c-btn--modal:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
